__turbopack_context__.v({
  "button-animation": "styles-module__Sc3K1a__button-animation",
});
